import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, KELURAHAN } from "../../../constants";
import { compress } from "lz-string";

const RootPath = BASE_URL;

export const dispatchGetData = (data, type) => {
  return {
    type: type,
    data,
  };
};

export const deleteDataAction = (data) => {
  return () => {
    return axios
      .delete(`${RootPath}/${data.path}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((response) => {
        toast.warning(`${data.title} Berhasil dihapus`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return response;
      })
      .catch((error) => {
        toast.error(`${error.response.data.message}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return error;
      });
  };
};

export const softDeleteDataAction = (data) => {
  return () => {
    return axios
      .post(`${RootPath}/${data.path}`, data.body, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((response) => {
        toast.warning(`${data.title} Berhasil dihapus`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return response;
      })
      .catch((error) => {
        toast.error(`${error.response.data.message}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return error;
      });
  };
};

export const postDataAction = (data) => {
  return () => {
    return axios
      .post(`${RootPath}/${data.path}`, data.body, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((response) => {
        toast.success(`${data.title} Berhasil ditambahkan`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return response;
      })
      .catch((error) => {
        toast.error(`${error.response.data.message}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return error;
      });
  };
};

export const editDataAction = (data) => {
  return () => {
    return axios
      .put(`${RootPath}/${data.path}`, data.body, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((response) => {
        toast.info(`${data.title} Berhasil diubah`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return response;
      })
      .catch((error) => {
        toast.error(`${error.response.data.message || ""}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return error;
      });
  };
};

export const getDataAction = (data) => {
  return (dispatch) => {
    if (data.local && localStorage.hasOwnProperty(data.type))
      return new Promise((resolve) => resolve(null));
    return axios
      .get(`${RootPath}/${data.path}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((response) => {
        if (data.local) {
          const r = response.data;
          if (data.type === KELURAHAN) {
            r.forEach((element) => {
              delete element.kecamatan.name;
            });
          }
          localStorage.setItem(data.type, compress(JSON.stringify(r)));
        } else dispatch(dispatchGetData(response.data, data.type));
        return response;
      })
      .catch((error) => {
        console.log(error);
        toast.error(
          `${error.response ? error.response.data.message : "Internet offline"
          }`,
          {
            position: toast.POSITION.BOTTOM_RIGHT,
          }
        );
      });
  };
};


export const change_var_filter = ({ prop, value }) => {
  return {
    type: 'change_var_filter',
    payload: { prop, value },
  };
};


export * from "./chartFilter";
